import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

export type AppDialogButtonConfig = {
  text: string;
  onClick: () => void | Promise<void>;
  className?: string;
  sx?: any;
};

export type AppDialogProps = {
  open: boolean;
  onClose: () => void;
  /** Optional title, or leave undefined to omit */
  title?: React.ReactNode;
  /** Main body content (can be string or JSX) */
  content: React.ReactNode;
  /** Optional width override */
  width?: number | string;
  /** Optional primary button config (info / confirm) */
  primaryButton?: AppDialogButtonConfig;
  /** Optional secondary button config (confirm) */
  secondaryButton?: AppDialogButtonConfig;
};

const AppDialog: React.FC<AppDialogProps> = ({
  open,
  onClose,
  title,
  content,
  width = 550,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "4px",
          padding: "20px 30px",
          width,
          maxWidth: "90%",
          textAlign: "center",
          boxShadow: "0 5px 15px rgba(0,0,0,.5)",
        },
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            fontSize: "20px",
            fontWeight: 600,
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          {title}
        </DialogTitle>
      )}

      <DialogContent>
        <DialogContentText
          sx={{
            fontSize: "17px",
            color: "#494440",
            textAlign: "center",
            marginBottom: "10px",
            fontWeight: 600,
            fontFamily: '"Montserrat", Verdana, sans-serif',
          }}
        >
          {content}
        </DialogContentText>
      </DialogContent>

      {(primaryButton || secondaryButton) && (
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "15px",
          }}
        >
          {secondaryButton && (
            <Button
              onClick={secondaryButton.onClick}
              className={secondaryButton.className}
              sx={{
                minWidth: 120,
                borderRadius: "4px",
                textTransform: "uppercase",
                ...(secondaryButton.sx || {}),
              }}
            >
              {secondaryButton.text}
            </Button>
          )}

          {primaryButton && (
            <Button
              onClick={primaryButton.onClick}
              className={primaryButton.className}
              sx={{
                minWidth: 120,
                borderRadius: "4px",
                textTransform: "uppercase",
                ...(primaryButton.sx || {}),
              }}
            >
              {primaryButton.text}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AppDialog;
